"use client";

import { ErrorFallback } from "@/shared/components/feedback/ErrorFallback";

/**
 * Root segment error boundary — renders inside the root layout's <html>/<body>.
 * Catches crashes in nested layouts/pages (including the authed (app) layout)
 * that the deeper (app)/error.tsx can't, since a layout's error bubbles to the
 * boundary above it. Root-layout crashes themselves fall through to global-error.
 */
export default function RootError({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <ErrorFallback error={error} reset={reset} />
    </div>
  );
}
